<div class="w-full">
  <ion-searchbar  
    show-clear-button="focus"
    placeholder="Búsqueda"
    animated="false"
    mode="ios"
    ></ion-searchbar>
</div>
